import { render, staticRenderFns } from "./ChannelDev.vue?vue&type=template&id=8e84699e&scoped=true"
import script from "./ChannelDev.vue?vue&type=script&lang=js"
export * from "./ChannelDev.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ChannelDev.vue?vue&type=style&index=1&id=8e84699e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e84699e",
  null
  
)

export default component.exports